module.exports = __webpack_public_path__ + "img/uv_off.c52834d6.png";